<div
  class="h-400 min-h-400 max-h-400 border-2 border-dashed border-gray-300 rounded-2xl"
>
  <div class="box">
    <i
      (click)="mainRoute()"
      class="dx-icon-back dx-icon-custom-style pointer"
    ></i>
    <h5 class="p-3">LOOKUPS</h5>
  </div>

  <div style="padding: 12px">
    <dk-ct-evet-hayir-radio
      [label]="'Ödeme Kontrolü'"
      [selectedValue]="'E'"
      (valueChange)="change()"
    ></dk-ct-evet-hayir-radio>
  </div>
  <div class="grid-3">

    <dk-ct-gen-lookup-coklu [labelText]="'Seçiniz'" [entityName]="'GenMahalleKoy'"></dk-ct-gen-lookup-coklu>
  </div>

  <div class="grid-3">
    <dk-ct-gen-lookup
      [placeholder]="'Evet Hayır'"
      [selectedValue]="yesNoCode"
      [lookUpType]="'GEN_EVETHAYIR'"
    ></dk-ct-gen-lookup>
    <dk-ct-gen-lookup
      [placeholder]="'İl Seçiniz'"
      [selectedValue]="provinceCode"
      [lookUpType]="'GEN_IL'"
      (onValueChange)="changeProvince($event)"
    ></dk-ct-gen-lookup>
    <dk-ct-gen-lookup
      [placeholder]="'İlçe Seçiniz'"
      [selectedValue]="districtCode"
      [mainCode]="provinceCode"
      [lookUpType]="'GEN_ILCE'"
      [disabled]="provinceCode <= 0"
      (onValueChange)="changeDistrict($event)"
    ></dk-ct-gen-lookup>
    <dk-ct-gen-lookup
      [placeholder]="'Kullanıcı Seçiniz'"
      [selectedValue]="usersCode"
      [lookUpType]="'GEN_KULLANICI'"
    ></dk-ct-gen-lookup>
    <dk-ct-gen-lookup
      [placeholder]="'Gelir Seçiniz'"
      [selectedValue]="incomeCode"
      [lookUpType]="'TEB_GELIR'"
      [periodCode]="periodCode"
    ></dk-ct-gen-lookup>
    <dk-ct-gen-lookup
      [placeholder]="'Sts - Ihale Maddeleri'"
      [selectedValue]="tenderCode"
      [lookUpType]="'STS_IHALE_MADDE'"
    ></dk-ct-gen-lookup>
    <dk-ct-gen-lookup
      [placeholder]="'Dönem Seçiniz'"
      [selectedValue]="periodCode"
      [lookUpType]="'TEB_DONEM'"
    ></dk-ct-gen-lookup>
    <dk-ct-gen-lookup
      [placeholder]="'Gider Seçiniz'"
      [selectedValue]="expenseCode"
      [lookUpType]="'TEB_GIDER'"
      [periodCode]="periodCode"
    ></dk-ct-gen-lookup>
    <dk-ct-gen-lookup
      [placeholder]="'TEB - K Cetvelleri İşlem Türü'"
      [selectedValue]="kRulerCode"
      [lookUpType]="'TEB_KCETVEL_ISLEM_TURU'"
      [periodCode]="periodCode"
    ></dk-ct-gen-lookup>
    <dk-ct-gen-lookup
      [placeholder]="'Tem Borç Alacak'"
      [selectedValue]="temBACode"
      [lookUpType]="'TEM_BA'"
    ></dk-ct-gen-lookup>
    <dk-ct-gen-lookup
      [placeholder]="'Tem Borç, Alacak, Borç Alacak'"
      [selectedValue]="temBABACode"
      [lookUpType]="'TEM_BABA'"
    ></dk-ct-gen-lookup>
    <dk-ct-gen-lookup
      [placeholder]="'Tem Defter Tür'"
      [selectedValue]="registryTypeCode"
      [lookUpType]="'TEM_DEFTER_TUR'"
    ></dk-ct-gen-lookup>
    <dk-ct-gen-lookup
      [placeholder]="'Tem Fiş - Fiş Tür'"
      [selectedValue]="receiptTypeCode"
      [lookUpType]="'TEM_FIS_FIS_TUR'"
    ></dk-ct-gen-lookup>
    <dk-ct-gen-lookup
      [placeholder]="'Tem Fiş - İşlem Kodları'"
      [selectedValue]="receiptProcessCode"
      [lookUpType]="'TEM_FIS_ISLEM_KOD'"
    ></dk-ct-gen-lookup>
    <dk-ct-gen-lookup
      [placeholder]="'Tem Fiş - İşlem Tür'"
      [selectedValue]="receiptProcessTypeCode"
      [lookUpType]="'TEM_FIS_ISLEM_TURU'"
    ></dk-ct-gen-lookup>
    <dk-ct-gen-lookup
      [placeholder]="'Tem Fiş - Odeme Tür'"
      [selectedValue]="receiptPaymentTypeCode"
      [lookUpType]="'TEM_FIS_ODEME_TURU'"
    ></dk-ct-gen-lookup>
    <dk-ct-gen-lookup
      [placeholder]="'Tem Hesap İşlem Şekli'"
      [selectedValue]="billProcessCode"
      [lookUpType]="'TEM_HESAP_ISLEM_SEKLİ'"
    ></dk-ct-gen-lookup>
    <dk-ct-gen-lookup
      [placeholder]="'Tem Hesap Tür'"
      [selectedValue]="billTypeCode"
      [lookUpType]="'TEM_HESAP_TUR'"
    ></dk-ct-gen-lookup>
    <dk-ct-gen-lookup
      [placeholder]="'Tem İmza Yetkili Türleri'"
      [selectedValue]="signatureAuthorityTypeCode"
      [lookUpType]="'TEM_IMZA_YETKI_TUR'"
      [periodCode]="periodCode"
    ></dk-ct-gen-lookup>
    <dk-ct-gen-lookup
      [placeholder]="'Ika Personel Rol'"
      [mainCode]="113"
      valueExpr="kod"
      [lookUpType]="'IKA_PERSONEL_ROL'"
    ></dk-ct-gen-lookup>
  </div>
</div>
